var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8682",
    "data-name": "Group 8682",
    transform: "translate(-927 -191)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2157",
    "data-name": "Ellipse 2157",
    cx: 45,
    cy: 45,
    r: 45,
    transform: "translate(927 191)",
    fill: "#f5f2ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Bold_Message",
    "data-name": "Iconly/Bold/Message",
    transform: "translate(955 221)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Message-2",
    "data-name": "Message",
    d: "M25.4,30H8.6A8.52,8.52,0,0,1,0,21.583V8.417A8.52,8.52,0,0,1,8.6,0H25.4a8.744,8.744,0,0,1,6.086,2.469A8.271,8.271,0,0,1,34,8.417V21.583A8.521,8.521,0,0,1,25.4,30ZM6.859,8.743a1.278,1.278,0,0,0-1.029,2.041L6.053,11l7.734,5.918A5.387,5.387,0,0,0,17.1,18.049a5.474,5.474,0,0,0,3.329-1.132L28.1,10.9l.136-.134a1.271,1.271,0,0,0-.02-1.666,1.424,1.424,0,0,0-.9-.434l-.072,0A1.306,1.306,0,0,0,26.365,9L18.7,15a2.693,2.693,0,0,1-1.694.6A2.74,2.74,0,0,1,15.3,15L7.65,9A1.34,1.34,0,0,0,6.859,8.743Z",
    fill: "#6631f7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailLogo);
export default __webpack_public_path__ + "static/media/email-logo.d2b54cc06be2e2aaaf06faa11981d7de.svg";
export { ForwardRef as ReactComponent };